export default __webpack_public_path__ + "static/media/information--turn-right--g1.eb673195.png";